import cookieCutter from 'cookie-cutter';

const __HS_COOKIE_NAME__ = 'hubspotutk';
const __HS_DEFAULT_COOKIE__ = '__nocookie__';

const isBrowser = () => typeof window !== 'undefined';

export default function getHSCookie(defaultCookie = '') {
  if (typeof defaultCookie !== 'undefined' && defaultCookie !== '') {
    return defaultCookie;
  }

  if (isBrowser()) {
    return cookieCutter.get(__HS_COOKIE_NAME__);
  }

  return __HS_DEFAULT_COOKIE__;
}
